// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"Global_mainDiv__2s-QC","mainInner":"Global_mainInner__3hzet","heading":"Global_heading__3gXlR","description":"Global_description__3gY4H","footer":"Global_footer__2gyQW"};